<div [queryParams]="queryParams" [routerLink]="routerLink" fxLayout="row" fxLayoutGap="1rem" style="cursor: pointer">

  <div data-qa="messages" fxFlex="7" fxLayout="column"
    fxLayoutAlign="space-around stretch">
    <img mat-card-sm-image src="/assets/eon-pictograms/digitalisation.svg">
  </div>

  <div data-qa="messages" fxFlex="60" fxLayout="column" fxLayoutAlign="space-around stretch">
    @if (invalidNetzzuordnungen > 1) {
      <span>{{invalidNetzzuordnungen}} Netzzuordnungen sind ungültig geworden.</span>
    } @else {
      {{invalidNetzzuordnungen}} Netzzuordnung ist ungültig geworden.
    }
    <span>Bitte prüfen Sie die Verknüpfungen in den jeweiligen Erzeugungsanlagen.</span>
  </div>
  <div class="notify-badge" data-qa="link" fxFlex="33" fxLayoutAlign="center center">
    <div class="badge-text">Jetzt aktualisieren</div>
  </div>
</div>
